export const getCharacterCount = (value?: string): number =>
  value ? value.length : 0;
